(function () {
  'use strict';

  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var openers = document.querySelectorAll('[data-search-open]');
    var closers = overlay.querySelectorAll('[data-search-close]');
    var input = overlay.querySelector('[data-search-input]');
    var form = overlay.querySelector('[data-search-form]');
    var lastFocus = null;

    function openSearch() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-search-open');
      requestAnimationFrame(function () {
        overlay.classList.add('is-active');
        if (input) {
          input.focus();
          input.select();
        }
      });
    }

    function closeSearch() {
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-search-open');
      setTimeout(function () {
        overlay.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 280);
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeSearch();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var query = input ? input.value.trim() : '';
        if (!query) e.preventDefault();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchOverlay);
  } else {
    initSearchOverlay();
  }
})();
